import React from "react";
import { ElectricPowerAlertSetting } from "./electric_power_alert/ElectricPowerAlertSetting";
import { useSelectedCareRecipient } from "../../hooks/care_recipient/useSelectedCareRecipient";
import { Loading } from "../common/Loading";
import classes from "./AlertSettingsPage.module.scss";

export function AlertSettingsPage() {

    const careRecipient = useSelectedCareRecipient();

    if (!careRecipient) {
        return (
            <Loading />
        );
    }

    return (
        <div className={classes.container}>
            <div className={classes.items}>
                <ElectricPowerAlertSetting careRecipient={careRecipient} />

            </div>
        </div>
    );
}

